<template>
  <div>
    <h1 class="d-flex flex-row justify-space-between align-center"><slot /></h1>
    <v-divider class="mb-4 mt-2"></v-divider>
  </div>
</template>

<script>
export default {}
</script>
